import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  Routes,
  Route,
  useLocation
} from 'react-router-dom';

import GenerateTab from './pages/GenerateTab';
import GenerateResult from './pages/GenerateResult';
import Draw from './pages/Draw';
import Signin from './pages/Signin';
import Paint from './pages/Paint';
import PurchaseTab from './pages/PurchaseTab';
import KakaoSignin from './pages/KakaoSignin';
import KakaoAuthRedirect from './pages/KakaoAuthRedirect';
import CompleteOAuth from './pages/CompleteOAuth';
import PurchaseFail from './pages/PurchaseFail';
import PurchaseSuccess from './pages/PurchaseSuccess';
import Subscribe from './pages/Subscribe';
import Me from './pages/Me';
import TaskImage from './pages/TaskImage';
import KakaoProfilePayment from './pages/KakaoProfilePayment';
import { AuthProvider } from './contexts/AuthContext';

import DirectPurchaseSuccess from './pages/DirectPurchaseSuccess';
import DirectPurchaseFail from './pages/DirectPurchaseFail';

import RequireAuth from './components/RequiredAuth';
import MobileSizedView from './components/MobileSizedView';

import PurchaseKakaoauth from './pages/TossRedirect/PurchaseKakaoauth';
import PurchaseAnswerit from './pages/Purchase/Answerit/Purchase';
import PurchaseAnsweritSuccess from './pages/Purchase/Answerit/Success';
import PurchaseAnsweritFail from './pages/Purchase/Answerit/Fail';

import Try from './pages/Purchase/Try';

const theme = createTheme({
  components: {
    MuiSlider: {
      styleOverrides: {
        root: {
          color: 'white',
        },
        thumb: {
          color: 'white',
        },

      }
    },
    MuiTextField: {
      // set border color
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'black',
            },
            '&:hover fieldset': {
              borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'black',
            },
          },
          // place holder color
          '& .MuiInputBase-input': {
            color: 'black',
          },
          // label color
          '& .MuiInputLabel-root': {
            color: 'black',
          },
          // label color when focused
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
        },
      },
    }
  }
});

function App() {
  return (
    <MobileSizedView
      style={{ backgroundColor: '#F6DADB' }}
      screenStyle={{
        backgroundColor: '#fefefe',
        boxShadow: '-31px -31px 62px #FAE0E0, 31px 31px 62px #EAB6BE',
      }}
      isRounded>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Routes>
            {/* <Route path="/" element={
              <RequireAuth>
                <GenerateTab />
              </RequireAuth>
            } /> */}

            <Route path="/" element={
              <GenerateTab />
            } />

            <Route path="/task/image" element={<TaskImage />} />
            <Route path="/me" element={<Me/>} />
            <Route path="/result" element={<GenerateResult />} />
            {/* <Route path="/draw" element={<Draw />} /> */}
            <Route path="/signin" element={<Signin />} />
            {/* <Route path="/paint" element={<Paint />} /> */}
            <Route path="/purchase" element={<PurchaseTab />} />
            <Route path="/purchase/success" element={<PurchaseSuccess />} />
            <Route path="/purchase/fail" element={<PurchaseFail />} />

            <Route path="/subscribe" element={<Subscribe />} />

            {/* 카카오 인증 봇 관련 페이지 */}
            <Route path="/signin/kakao" element={<KakaoSignin />} />
            <Route path="/oauth/callback/kakao" element={<KakaoAuthRedirect />} />
            <Route path="/oauth/complete" element={<CompleteOAuth />} />


            {/* 외부결제... */}
            <Route path="/kakao/profile/payment" element={<KakaoProfilePayment />} />

            {/* 간편결제 콜백 */}
            <Route path="/purchase/direct/success" element={<DirectPurchaseSuccess />} />
            <Route path="/purchase/direct/fail" element={<DirectPurchaseFail />} />

            {/* 결제 쓰는거 가상번호 인증 서비스 */}
            <Route path="/purchase/try" element={<Try />} />
            <Route path="/purchase/redirect/kakaoauth/success" element={<PurchaseKakaoauth />} />

            {/* 결제 프록시 */}
            <Route path="/purchase/answerit" element={<PurchaseAnswerit />} />
            <Route path="/purchase/answerit/success" element={<PurchaseAnsweritSuccess />} />
            <Route path="/purchase/answerit/fail" element={<PurchaseAnsweritFail />} />

          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </MobileSizedView>
  );
}

export default App;
